"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessengerClient = void 0;
const MessengerClient_1 = __importDefault(require("./MessengerClient"));
exports.MessengerClient = MessengerClient_1.default;
//# sourceMappingURL=index.js.map